
$( document ).ready(function() {
  $(".rmore").on("click", function() {
    $('span.dots').hide()
    $(this).hide()
    $(".read-less").show()
    $(".more-dear").show()
  })
  $(".read-less").on("click", function() {
    $('span.dots').show()
    $(this).hide()
    $(".rmore").show()
    $(".more-dear").hide()
    $('html, body').animate({
        scrollTop: $('#shopify-section-162633482867592561').offset().top
    }, 2000);
  })

  if ($('.img-story').html() != '') {
    var img = $('.img-story').data('img')
    $('.img-story').html(`<img src="${img}">`)
  }

  if ( !$('.template-index').length) {
      var links = $('#SiteNavLabel-fitness-programs li a,.site-footer__item:nth-child(2) ul.site-footer__linklist a,li.mobile-nav__item:nth-of-type(5) a,a.mobile-nav__sublist-link[href^="#"]')

      $(links).each( function(i,e) {
        var url = $(this).attr('href') 
        var new_link = `https://andreiaspage.myshopify.com/${url}`
        $(this).attr('href', new_link) 
      })
      var about = $('ul#SiteNav li:nth-of-type(5) a')
      $(about).attr('href', `https://andreiaspage.myshopify.com/#shopify-section-1626418327912d615f`)
  }
  $('.level-front .discover-btn').click(function() {
      var lvlbtns = $(this).parents('.level-front').find('.level-btns')
      var content = $(this).parents('.level-front').find('.content-level')
      var title = $(this).data('title')
      // $(this).parents('.level-front').siblings().find('.level-btns').slideToggle()
      // $(this).parents('.level-front').siblings().find('.content-level').slideToggle()
      $('.prod-show .show-title').text(title)
      $('.prod-show').removeClass('at-home').removeClass('gym').removeClass('bundles').addClass(title.toLowerCase().replace(/ /g,'-'))




      if ( $(this).data('type') == 'competition-program') {

        window.location.href = "/products/competition-program";

      } else if ( $(this).data('type') == 'recipe-guide' ) {
        
        window.location.href = '/products/healthy-easy-delicious-recipe-guide';
        
      } else {
        lvlbtns.slideToggle()
        content.slideToggle()
      }

  })

  $('.related-tag.recom-prods').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      prevArrow: `<div class="slick-arrow arrow-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12 C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084 c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864 l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
      nextArrow: `<div class="slick-arrow arrow-right"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
  });
  $('.before-after').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    lazyload: 'ondemand',
    prevArrow: `<div class="slick-arrow arrow-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12 C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084 c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864 l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
    nextArrow: `<div class="slick-arrow arrow-right"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.dear-content .icon-close').click( function(){
      $('.par-sec').slideToggle()
  })

  $('.lvl-sel').on( 'click', function() {
      $('.front-content').slideToggle()
      $('.sec-content').slideToggle()
      $('.content-level').show()
      $('.level-btns').hide()



      var loading = `<div class="loading"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <g transform="rotate(0 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(30 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(60 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(90 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(120 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(150 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(180 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(210 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(240 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(270 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(300 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"/>
        </rect>
      </g><g transform="rotate(330 50 50)">
        <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#abd0f2">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/>
        </rect>
      </g>
      <!-- [ldio] generated by https://loading.io/ --></svg></div>`


      var coll_id = $(this).data('id')
      var coll_type = $(this).data('type')
      var coll_handle = $(this).data('collection')
      
      $(`.sec-content .grid__item[data-type="${coll_type}"]`).hide()

      if ( coll_id != '' ) {
          $(loading).appendTo('.prod-show')

          $.ajax({
              url:	`/collections/${coll_id}?view=json`,
              crossDomain: true,
              type:	'GET',
              headers: {
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json',
                  // "Authorization": "Basic " + btoa('2ca41f1266565824a1959ba780607f7a' + ":" + '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'),
                  // 'X-Shopify-Storefront-Access-Token':'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'
              }
          }) 

          .done(function(data) {
              var productList = data;
              var product = $.parseJSON(data);

              if ($(window).width() <= 749) {
                $('html, body').animate({
                  scrollTop: $(".level-sec").offset().top - 70
                }, 1000);
             }


              $(product.product).each(function(index) {
                  
                  var saleBdge =  this.compare_at_price != '' ? '<div class="sale-top">Sale</div>' : '';
                  var saveTxt =  `<div class="save-txt">Save ${this.save}</div>`;
                  var startWt = this.tag == "start-with" ? '<div class="start-with"> Start With </div>' : '';
                  var short = this.short_desc
                  var products = 
                  
                  `<div class="grid-view-item text-center product-card">
                  ${saleBdge}
                  <a class="grid-view-item__link grid-view-item__image-container full-width-link" href="${this.handle}">
                  <span class="visually-hidden">${this.title}</span>
                  </a>
                  <div class="product-card__image-with-placeholder-wrapper">
                  <div id="ProductCardImageWrapper-collection-${this.id}" class="grid-view-item__image-wrapper product-card__image-wrapper js">
                      <div style="padding-top:100.0%;">
                      <img id="ProductCardImage-collection-${this.id}" class="grid-view-item__image lazyautosizes lazyload" alt="${this.alt}" src="${this.image}">
                      </div>
                  </div>
                  </div>
              
                  <noscript>
                  
                  <img class="grid-view-item__image" src="${ this.image }" alt="" style="max-width: 250.0px;">
                  </noscript>
                  ${startWt}
                  <div class="h4 grid-view-item__title product-card__title" aria-hidden="true">${ this.title }</div>
                  <div class="text-center">
                    <span class="shopify-product-reviews-badge" data-id="${this.id}"></span>
                  </div>
                  
              <dl class="price price--listing price--on-sale ">

              <div class="price__regular">
                  <dt>
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  </dt>
                  <dd>
                      <span class="price-item price-item--regular">${ theme.Currency.formatMoney(this.price)}
                  </span>
                  </dd>
                  </div>
                      <div class="price__sale">
                      <dt>
                          <span class="visually-hidden visually-hidden--inline">Sale price</span>
                      </dt>
                      <dd>
                          <span class="price-item">${theme.Currency.formatMoney(this.price)}
                  </span>
                  </dd>
                  </div>
                  <div class="price__unit">
                  <dt>
                      <span class="visually-hidden visually-hidden--inline">Unit price</span>
                  </dt>
                  <dd class="price-unit-price"><span></span><span aria-hidden="true">/</span><span class="visually-hidden">per&nbsp;</span><span></span></dd>
                  </div>
                  <div class="price__badges price__badges--listing">
                  <span class="price__badge price__badge--sold-out">
                      <span>Sold out</span>
                  </span>
                  </div>
                  ${ this.compare_at_price != '' ? '<!--<div class="striked">striked</div>-->' : ''}
                  <div class="price__compare">
                  <dt>
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  </dt>
                  <dd>
                  <s class="price-item price-item--regular">
                  ${ this.compare_at_price != '' ? theme.Currency.formatMoney(this.compare_at_price) : ''}
                  </s>
                  </dd> 
              </div>
              </dl>
              ${ this.compare_at_price != '' ? saveTxt : ""}
              <div class="shorty">
              ${short}
              </div>
              <div class="btns d-flex">
                  <div>
                      <a href="${this.handle}" class="btn btn1 btn-buy">Buy now</a>
                  </div>
                  <div>
                      <a href="${this.handle}" class="btn btn2 btn-explore">Explore ></a>
                  </div>
              </div>
              </div>`

                  $(products).appendTo('.products-lvl')

                  setTimeout(function(){
                      $('.products-lvl').slick({
                          infinite: false,
                          slidesToShow: 2,
                          slidesToScroll: 2,
                          arrows: true,
                          prevArrow: `<div class="slick-arrow arrow-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12 C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084 c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864 l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
                          nextArrow: `<div class="slick-arrow arrow-right"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
                          responsive: [
                              {
                                breakpoint: 749,
                                settings: {
                                  slidesToShow: 1,
                                  slidesToScroll: 1,
                                  infinite: false,
                                  dots: true
                                }
                              }
                            ]
                      },$('.prod-show .loading').remove());
                  }, 100);

              });
              var id = $(this).parents('shopify-section').id;

          })
          .fail(function(data) {
              alert('Please apply collection this level.')
          })
          .always(function(data) {
          });
      }
  })

  $('.back-arrow').click( function() {
      $('.front-content,.sec-content').slideToggle()
      $('.products-lvl').slick('unslick');
      $('.products-lvl').html('')
      $(`.sec-content .grid__item`).show()
  }) 

  $('.add').click( function() {
      $('.front-content,.sec-content').slideToggle("slow")
      $('.products-lvl').slick('unslick');
      $('.products-lvl').html('')
      $(`.sec-content .grid__item`).show()
       
      var type = $(this).data('type')

      var content = $(`.level-front[data-type="${type}"]`)
      $('html, body').animate({
        scrollTop: $(content).offset().top
      }, 500);

      $(`.discover-btn[data-type="${type}"]`).trigger('click')

  }) 


  $('a[data-vid]').click(function() {
      event.preventDefault()
      var url = $(this).data('vid')
      var video = `<iframe src="https://player.vimeo.com/video/${url}?title=0&byline=0&autoplay=1" class="frame-vid" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`
      var vidContainer = $(this).parents('.vid-con')
      var image = $(vidContainer).find('.video__image')
  
      image.hide()
      $(this).hide()
      $(video).appendTo(vidContainer)
  })
  $('.thumb-con').click( function(){
      $('a[data-vid]').show()
      $('.video__image').show()
      $('.vid-con iframe').remove()
  }) 
  $('.video-showcase').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyload: 'ondemand',
      arrows: false,
      fade: true,
      asNavFor: '.slide-thumbs'
  })

  $('.slide-thumbs').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      lazyload: 'ondemand',
      arrows: true,
      asNavFor: '.video-showcase',
      prevArrow: `<div class="slick-arrow arrow-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12 C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084 c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864 l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
      nextArrow: `<div class="slick-arrow arrow-right"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
      dots: true,
      focusOnSelect: true,
      responsive: [
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 3,
            }
          }
      ]
  });

  $('.reviews-slide').slick({
      prevArrow: '.btn-reviews .arrow-left',
      nextArrow: '.btn-reviews .arrow-right',
      centerMode: true,
      arrows: true,
      centerPadding: '60px',
      slidesToShow: 2,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1
          }
        }
      ]
  });

  $('.slide-gal').slick({
      infinite: true,
      speed: 300,
      arrows: true,
      prevArrow: `<div class="slick-arrow arrow-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12 C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084 c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864 l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
      nextArrow: `<div class="slick-arrow arrow-right"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
      slidesToShow: 3,
      responsive: [
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 1
            }
          }
      ]
  });
  $('.blog-loop').slick({
      centerMode: true,
      slidesToShow: 3,
      arrows: false,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
  });
  $('.accordion-title').click( function(){
      $(this).find('p').slideToggle()

      if ( $(this).hasClass('is-open') ) {
          $('.accordion-title').removeClass('is-open')
      } else {
          $(this).addClass('is-open')
      }
  })

  $('.qtyBtn').on('click', function(){
      var qty = parseInt($(this).parent('.qtyField').find('.quantity-input').val());
      if($(this).hasClass('qtyplus')) {
        qty++;
      }else {
        if(qty > 1) {
          qty--;
        }
      }
      qty = (isNaN(qty))?1:qty;
      $(this).parent('.qtyField').find('.quantity-input').val(qty);
  }); 

  // handle links with @href started with '#' only
  $(document).on('click', 'a[href^="#"]', function(e) {
      // target element id
      var id = $(this).attr('href');

      // target element
      var $id = $(id);
      if ($id.length === 0) {
          return;
      }

      // prevent standard hash navigation (avoid blinking in IE)
      e.preventDefault();


      $(window).resize(function() {
        if ($(window).width() <= 749) {
        // top position relative to the document
        var pos = $id.offset().top - 400; 
        }
       else {
        // top position relative to the document
        var pos = $id.offset().top - 65; 
       }
      });
      
      if ($(window).width() <= 749) {
        // top position relative to the document
        var pos = $id.offset().top - 400;
      }
      else {
        // top position relative to the document
        var pos = $id.offset().top - 65; 
      }

      // animated top scrolling
      $('body, html').animate({scrollTop: pos});
  });


    // handle links with @href started with '#' only
    $(document).on('click', 'a.mobile-nav__sublist-link[href^="#"],a.mobile-nav__link[href^="#"]', function(e) {
      // target element id
      var id = $(this).attr('href');

      // target element
      var $id = $(id);
      if ($id.length === 0) {
          return;
      } else {
        $('.js-mobile-nav-toggle').trigger('click')
      }

    })

  $('.abslide-init').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: `<div class="slick-arrow arrow-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12 C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084 c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864 l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
    nextArrow: `<div class="slick-arrow arrow-right"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  })

  if ( $('.counter').length ) {
      // Check if an element was in a screen
      function isScrolledIntoView(elem){
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();
        return ((elemBottom <= docViewBottom));
    }
  }

  function abbreviateNumber(value) {
      var newValue = value;
      if (value >= 1000) {
          var suffixes = ["", "k+", "m+", "b+","t+"];
          var suffixNum = Math.floor( (""+value).length/3 );
          var shortValue = '';
          for (var precision = 2; precision >= 1; precision--) {
              shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
              var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
              if (dotLessShortValue.length <= 2) { break; }
          }
          if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
          newValue = shortValue+suffixes[suffixNum];
      }
      return newValue;
  }
//Count up code
function countUp() {
    $('.counter').each(function() {
      var $this = $(this), // <- Don't touch this variable. It's pure magic.
          countTo = $this.attr('data-count');
          ended = $this.attr('ended');

    if ( ended != "true" && isScrolledIntoView($this) ) {
        $({ countNum: $this.text()}).animate({
        countNum: countTo
      },
      {
        duration: 800, //duration of counting
        easing: 'swing',
        step: function() {
          $this.text(Math.trunc(this.countNum));
          $this.addClass('littler');
        },
        complete: function() {
          $this.removeClass('littler');
          $this.text(abbreviateNumber(this.countNum));
        }
      });
    $this.attr('ended', 'true');
    }
    });
}
if ( $('.counter').length ) {
    //Start animation on page-load
    if ( isScrolledIntoView(".counter") ) {
      countUp();
  }
}
if ( $('.counter').length ) {
  $(window).scroll(function () {

    if ( isScrolledIntoView(".counter") ) {
        countUp();
    }
  });
}

  $('.logo-slide').slick({
    infinite: true,
    slidesToShow: 8,
    slidesToScroll: 8,
    prevArrow: `<div class="slick-arrow arrow-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12 C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084 c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864 l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
    nextArrow: `<div class="slick-arrow arrow-right"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve" width="20px" height="20px" fill="#fff"><g><g><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }
    ]
  },$('.logo-slide ').show());

  if ($(window).width() <= 749) {
    $('.wrap-timer').appendTo('body')
  } else {
    $('.wrap-timer').prependTo('.site-header__icons-wrapper')
  }

    $(window).resize(function() {
      if ($(window).width() <= 749) {
            $('.wrap-timer').appendTo('body')
      } else {
        $('.wrap-timer').prependTo('.site-header__icons-wrapper')
      }
    });
  $('.close-announce').click( function() {
      $('.announcement-bar').slideToggle();
  })
  setTimeout(function(){
    $('.announcement-bar').slideToggle();
  }, 1000); 
});

$(window).on('load', function() {
// if ($('div#shopify-section-stamped_reviews:contains("No reviews yet")').length == 0) {
//     $("div#shopify-section-reviews").hide()
// }
$(window).resize(function() {
  if ($(window).width() <= 749) {

    if ($('.mob-options').length ) {
      setTimeout(function(){ 
        $('.desk-inner').appendTo('.mob-options')
       }, 500);
    }
  } else {
    $('.mob-options .desk-inner').appendTo('.desk-form')
  }
});
if ($(window).width() <= 749) {

  if ($('.mob-options').length ) {
    setTimeout(function(){ 
      $('.desk-inner').appendTo('.mob-options')
    }, 500);
  }
}

})

$(window).scroll(function () {
if($(window).scrollTop() > 180) {
  $(".site-header").addClass('sticky-nav',{duration:500});
  $('body').addClass('padded',{duration:500})
} else { 
  $(".site-header").removeClass('sticky-nav',{duration:500});
  $('body').removeClass('padded',{duration:500})
}
});

$('.back-to').click( function() {
  event.preventDefault();
  window.location.href = `https://andreiabrazier.com/#shopify-section-1631071698956212c6`;
}) 
